<template>
  <v-checkbox v-model="value" :label="text" @change="valueChanged"/>
</template>

<script>
export default {
  name: "PermissionCheckbox",
  props: ['data', 'text', 'code'],
  data() {
    return {
      value: null
    }
  },
  watch: {
    data: {
      handler(state) {
        this.value = state
      }
    }
  },
  mounted() {
    this.value = this.data
  },
  methods: {
    valueChanged() {
      let data = {
        value: this.value,
        code: this.code
      }
      this.$emit('valueChanged', data)
    }
  }
}
</script>

<style scoped>

</style>
